var map = {
	"./california.json": [
		5212,
		212
	],
	"./gaza.json": [
		8455,
		455
	],
	"./iran.json": [
		7466,
		466
	],
	"./japan.json": [
		962,
		962
	],
	"./lebanon.json": [
		563,
		563
	],
	"./russia.json": [
		2011,
		11
	],
	"./tehran.json": [
		200,
		200
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4275;
module.exports = webpackAsyncContext;